import { Leaf, LogOut, LayoutDashboard, Camera, Sparkles, Crown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { NOTCH } from "@/constants/testIds";

export default function AppHeader() {
  const { user, billing, logout } = useAuth();
  const loc = useLocation();
  const isPro = billing?.subscription_status === "active";

  return (
    <header className="max-w-6xl mx-auto px-4 sm:px-8 pt-6 sm:pt-8 pb-2 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2" data-testid={NOTCH.appBrand}>
        <div className="h-8 w-8 rounded-full bg-[#2C4C3B] flex items-center justify-center">
          <Leaf size={16} className="text-[#F9F8F6]" />
        </div>
        <span className="font-serif-display text-2xl tracking-tight text-[#2C4C3B]">Notch</span>
      </Link>

      <nav className="flex items-center gap-1 sm:gap-2">
        {user && user !== false && (
          <>
            <NavLink to="/" active={loc.pathname === "/"} icon={<Sparkles size={14} />} label="Plan" />
            <NavLink to="/dashboard" active={loc.pathname === "/dashboard"} icon={<LayoutDashboard size={14} />} label="Plans" testid={NOTCH.navDashboard} />
            <NavLink to="/photolog" active={loc.pathname.startsWith("/photolog")} icon={<Camera size={14} />} label="Photo log" testid={NOTCH.navPhotoLog} />
            <NavLink to="/pricing" active={loc.pathname === "/pricing"} icon={<Crown size={14} />} label="Pro" testid={NOTCH.navPricing} />
            {isPro ? (
              <span data-testid={NOTCH.proBadge} className="ml-2 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#2C4C3B] text-white text-[10px] uppercase tracking-[0.16em]" title="Plans this month">
                <Crown size={11} /> Pro · {billing?.pro_gen_used ?? 0}/{billing?.pro_gen_limit ?? "–"}
              </span>
            ) : billing && (
              <span data-testid={NOTCH.freeBadge} className="ml-2 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#F2EFE9] text-[#666] text-[10px] uppercase tracking-[0.16em] border border-[#E5E2DC]">
                {billing.free_remaining}/{billing.free_limit} free
              </span>
            )}
            <button
              data-testid={NOTCH.navLogout}
              onClick={logout}
              className="ml-2 inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs text-[#666] hover:text-[#2C4C3B] hover:bg-[#F2EFE9] transition-colors"
              title="Sign out"
            >
              <LogOut size={13} />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </>
        )}
        {user === false && (
          <Link to="/auth" className="text-sm text-[#2C4C3B] font-medium hover:underline">Sign in</Link>
        )}
      </nav>
    </header>
  );
}

function NavLink({ to, active, icon, label, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs transition-colors ${
        active ? "bg-[#2C4C3B] text-white" : "text-[#666] hover:text-[#2C4C3B] hover:bg-[#F2EFE9]"
      }`}
    >
      {icon}{label}
    </Link>
  );
}
